import axios from "axios";
import {
  handleExpiredSession,
  isTokenExpired,
} from "../../utils/helpers/authSession";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

// Public paths that should not trigger session expiry redirects
const PUBLIC_PATHS = [
  "/resetpassword",
  "/user-verification",
  "/UserVerification",
  "/MakeNewPassword",
  // "/quote",
  // "/form",
  "/server-login",
  "/server-timeout",
  "/chatWidget",
];

const isPublicPage = () => {
  const path = window.location.pathname;
  return PUBLIC_PATHS.some((publicPath) => path.startsWith(publicPath));
};

export const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  function (config) {
    const sessionId = window.localStorage.getItem("session-id");
    const token = window.localStorage.getItem("token");
    const contactId = window.localStorage.getItem("active-contact");
    const keepMeLoggedIn =
      window.localStorage.getItem("keepMeLoggedIn") === "true";
    const authSessionActive =
      window.sessionStorage.getItem("authSessionActive") === "true";

    // Skip auth checks on public pages — just clear stale token and proceed
    if (isPublicPage()) {
      if (token) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("tokenExpiry");
        window.sessionStorage.removeItem("authSessionActive");
        window.localStorage.removeItem("keepMeLoggedIn");
      }
      return config;
    }

    if (token && !keepMeLoggedIn && !authSessionActive) {
      window.localStorage.clear();
      window.sessionStorage.removeItem("authSessionActive");
      window.location.replace("/");
      return new Promise(() => {});
    }
    if (token && isTokenExpired()) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "Your session has expired. Please log in again to continue.",
        },
        false,
      );
      window.localStorage.clear();
      window.sessionStorage.removeItem("authSessionActive");
      window.localStorage.setItem(
        "sessionExpiredMessage",
        "Session expired. Please log in again.",
      );
      setTimeout(() => {
        window.location.replace("/");
      }, 1500);

      return new Promise(() => {});
    }
    if (sessionId) {
      config.headers["session-id"] = sessionId;
    }
    if (contactId) {
      config.headers["contact-id"] = contactId;
    }
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error?.response?.status;
    if (status === 401 && !isPublicPage()) {
      handleExpiredSession();
    }
    return Promise.reject(error);
  },
);
